/* unplugin-vue-components disabled */import { render } from "./settingsItem.vue?vue&type=template&id=53657cfc&scoped=true"
import script from "./settingsItem.vue?vue&type=script&lang=js"
export * from "./settingsItem.vue?vue&type=script&lang=js"

import "./settingsItem.vue?vue&type=style&index=0&id=53657cfc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53657cfc"]])

export default __exports__